import { render, staticRenderFns } from "./PayfastPayment.vue?vue&type=template&id=20b782c0&scoped=true"
import script from "./PayfastPayment.vue?vue&type=script&lang=js"
export * from "./PayfastPayment.vue?vue&type=script&lang=js"
import style0 from "./PayfastPayment.vue?vue&type=style&index=0&id=20b782c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b782c0",
  null
  
)

export default component.exports